/* global axios */

import ApiClient from './ApiClient';

class ConversationPipelineAPI extends ApiClient {
  constructor() {
    super('conversation_pipelines', { accountScoped: true });
  }

  createProcess(data) {
    return axios.post(this.url, data);
  }

  updateProcess(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  createStage(processId, data) {
    return axios.post(`${this.url}/${processId}/stages`, data);
  }

  updateStage(processId, id, data) {
    return axios.patch(`${this.url}/${processId}/stages/${id}`, data);
  }

  deleteStage(processId, id) {
    return axios.delete(`${this.url}/${processId}/stages/${id}`);
  }

  reorderStages(processId, stageIds) {
    return axios.patch(`${this.url}/${processId}/stages/reorder`, {
      stage_ids: stageIds,
    });
  }

  getConversations(processId) {
    return axios.get(`${this.url}/${processId}/conversations`);
  }

  moveConversation(processId, conversationId, stageId) {
    return axios.patch(`${this.url}/${processId}/conversations/${conversationId}`, {
      stage_id: stageId,
    });
  }
}

export default new ConversationPipelineAPI();
